export const Types = {
  GET_LIST_EXTRATO_PAGO: "extratoPago/GET_LIST_EXTRATO_PAGO",
  GET_LIST_EXTRATO_PAGO_SUCCESS: "extratoPago/GET_LIST_EXTRATO_PAGO_SUCCESS",
  GET_EXTRATO_PAGO: "extratoPago/GET_EXTRATO_PAGO",
  GET_EXTRATO_PAGO_SUCCESS: "extratoPago/GET_EXTRATO_PAGO_SUCCESS",
  CHANGE_PAGE_EXTRATO_PAGO: "extratoPago/CHANGE_PAGE_EXTRATO_PAGO",
  CHANGE_ROWS_PER_PAGE_EXTRATO_PAGO:
    "extratoPago/CHANGE_ROWS_PER_PAGE_EXTRATO_PAGO",
  GET_LIST_EXTRATO_PAGO_SUCCESS_SELECTS:
    "extratoPago/GET_LIST_EXTRATO_PAGO_SUCCESS_SELECTS",
  CHANGE_FILTER: "extratoPago/CHANGE_FILTER",
  DELETE_EXTRATO_PAGO: "extratoPago/DELETE_EXTRATO_PAGO",
  GET_LIST_PROPOSTAS_SUCCESS: "extratoPago/GET_LIST_PROPOSTAS_SUCCESS"
};

const INITIAL_STATE = {
  data: [],
  dataPayload: [],
  dataList: [],
  loadingSelect: false,
  item: {},
  filter: {},
  page: 0,
  rowsPerPage: localStorage.getItem("@ecorban-app:rows")
    ? parseInt(localStorage.getItem("@ecorban-app:rows"), 10)
    : 10,
  print: "",
  filtro: {},
  propostas: [],
  total_financed: 0,
  total_released: 0,
  total_value_installment: 0,
  total_repassado: 0,
  total_comissioned_total: 0,
  estornosPayload: [],
  total_financed_estornos: 0,
  total_released_estornos: 0,
  total_comissioned_total_estornos: 0,
  discountsPayload: [],
  total_amount_discounts: 0,
  bonusPayload: [],
  total_amount_bonus: 0,
  totais: {},
  totals: {}
};

export default function extratoPago(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_LIST_EXTRATO_PAGO:
      return { ...state };
    case Types.GET_LIST_EXTRATO_PAGO_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        dataPayload: action.payload.extratoPagoPayload,
        filtro: action.payload.filtro,
        totais: action.payload.totais
      };
    case Types.GET_EXTRATO_PAGO_SUCCESS:
      return {
        ...state,
        item: {
          date: action.payload.date,
          group: action.payload.group,
          group_id: action.payload.group_id
        }
      };
    case Types.CHANGE_PAGE_EXTRATO_PAGO:
      return { ...state, page: action.payload.page };
    case Types.CHANGE_ROWS_PER_PAGE_EXTRATO_PAGO:
      return { ...state, rowsPerPage: action.payload.total };
    case Types.GET_LIST_EXTRATO_PAGO_SELECTS:
      return { ...state, loadingSelect: true };
    case Types.GET_LIST_EXTRATO_PAGO_SUCCESS_SELECTS:
      return {
        ...state,
        dataList: action.payload.extratoPago,
        loadingSelect: false
      };
    case Types.CHANGE_FILTER:
      return {
        ...state,
        filter: action.payload.data
      };
    case Types.DELETE_EXTRATO_PAGO:
      return { ...state };
    case Types.GET_LIST_PROPOSTAS_SUCCESS:
      return {
        ...state,
        propostas: action.payload.data,
        total_financed: action.payload.total_financed,
        total_released: action.payload.total_released,
        total_comissioned_total: action.payload.total_comissioned_total,
        estornosPayload: action.payload.estornosPayload,
        total_financed_estornos: action.payload.total_financed_estornos,
        total_released_estornos: action.payload.total_released_estornos,
        total_comissioned_total_estornos:
          action.payload.total_comissioned_total_estornos,
        discountsPayload: action.payload.discountsPayload,
        total_amount_discounts: action.payload.total_amount_discounts,
        bonusPayload: action.payload.bonusPayload,
        total_amount_bonus: action.payload.total_amount_bonus,
        totals: action.payload.totals,
        pdf: action.payload.pdf
      };
    default:
      return state;
  }
}

export const Creators = {
  getListExtratoPago: filtro => ({
    type: Types.GET_LIST_EXTRATO_PAGO,
    payload: { filtro }
  }),
  getListExtratoPagoSuccess: (data, extratoPagoPayload, filtro, totais) => ({
    type: Types.GET_LIST_EXTRATO_PAGO_SUCCESS,
    payload: {
      data,
      extratoPagoPayload,
      filtro,
      totais
    }
  }),
  getExtratoPago: (date, group, group_id) => ({
    type: Types.GET_EXTRATO_PAGO,
    payload: { date, group, group_id }
  }),
  getExtratoPagoSuccess: (date, group, group_id) => ({
    type: Types.GET_EXTRATO_PAGO_SUCCESS,
    payload: { date, group, group_id }
  }),
  changeExtratoPagoPage: page => ({
    type: Types.CHANGE_PAGE_EXTRATO_PAGO,
    payload: { page }
  }),
  changeExtratoPagoRowsPerPage: total => ({
    type: Types.CHANGE_ROWS_PER_PAGE_EXTRATO_PAGO,
    payload: { total }
  }),
  getListExtratoPagoSuccessSelects: extratoPago => ({
    type: Types.GET_LIST_EXTRATO_PAGO_SUCCESS_SELECTS,
    payload: { extratoPago }
  }),
  changeFilter: data => ({
    type: Types.CHANGE_FILTER,
    payload: { data }
  }),
  deleteExtratoPago: () => ({
    type: Types.DELETE_EXTRATO_PAGO
  }),
  getListPropostasSuccess: (
    data,
    total_financed,
    total_released,
    total_comissioned_total,
    estornosPayload,
    total_financed_estornos,
    total_released_estornos,
    total_comissioned_total_estornos,
    discountsPayload,
    total_amount_discounts,
    bonusPayload,
    total_amount_bonus,
    totals,
    pdf
  ) => ({
    type: Types.GET_LIST_PROPOSTAS_SUCCESS,
    payload: {
      data,
      total_financed,
      total_released,
      total_comissioned_total,
      estornosPayload,
      total_financed_estornos,
      total_released_estornos,
      total_comissioned_total_estornos,
      discountsPayload,
      total_amount_discounts,
      bonusPayload,
      total_amount_bonus,
      totals,
      pdf
    }
  })
};



// WEBPACK FOOTER //
// ./src/store/ducks/extratoPago.js